import React from "react";
import {CaretDownOutlined} from '@ant-design/icons';
import {Select} from 'antd';
import Util from "../../public/utils";

// 用法示例

/*
optionList:数据源
selected:返回值
optionKey:单条数据源键值，数据是对象时必填，数据时数组时不填
value:当前选中值,必填
valueKey:单条数据value键值，选填，不填默认使用索引值
*/

{/*
对象数据源；optionList:[{id:1,name:'sadsa'},{id:1,name:'的的事'}]
    <Select optionList={this.state.optionList} selected={this.getSelected.bind(this)}
            optionKey={'name'}
    ></Select>
*/
}

{/*
数组数据源；optionList:[1，2，3，4]
    <Select optionList={this.state.optionList} selected={this.getSelected.bind(this)}
    ></Select>
*/
}


const Option = Select.Option;

class ComSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionList: props.optionList,
            value: this.props.value
        }
    }

    componentDidMount() {
        $('.pubSelect').on('mouseenter', '.ant-select-dropdown', function () {
            Util.disableScroll();
        });
        $('.pubSelect').on('mousemove', '.ant-select-dropdown', function () {
            Util.disableScroll();
        });
        $('.pubSelect').on('mouseleave', '.ant-select-dropdown', function () {
            Util.enableScroll();
        })
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.value != this.state.value) {
            this.setState({
                value: nextProps.value
            })
        }
        if (nextProps.optionList != this.props.optionList) {
            this.setState({
                optionList: nextProps.optionList
            })
        }
    }

    selectChange(val) {
        this.setState({
            value: val
        });
        this.props.selected ? this.props.selected(val) : ''
    }

    render() {
        return (
            <span className={`pubSelect ${this.props.className ? this.props.className : ''}`}>
                <Select defaultValue={null} style={this.props.style ? this.props.style : {width: 120}}
                        value={this.state.value}
                        getPopupContainer={triggerNode => triggerNode.parentNode}
                        suffixIcon={<CaretDownOutlined/>}
                        disabled={this.props.disabled}
                        onChange={this.selectChange.bind(this)}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) => {
                            let optionVal = option.props.children + '';
                            return (
                                optionVal.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            )
                        }
                        }
                >
                    {
                        this.state.optionList && this.state.optionList.length > 0 ?
                            this.state.optionList.map((data, i) => {
                                return (
                                    <Option value={this.props.valueKey ? data[this.props.valueKey] : i}>
                                        {
                                            this.props.optionKey ? data[this.props.optionKey] : data
                                        }
                                    </Option>
                                )
                            }) : <Option value=''>暂无数据</Option>
                    }
                </Select>
            </span>
        );
    }

}

export default ComSelect